import React, {Component} from 'react';

const TextAreaField = ({input, placeholder, meta: { touched, error, warning }, className}) => { 
    return (
        <div>
            <textarea {...input} placeholder={placeholder} className={className} rows="5" cols="28"/>
            {touched &&
        ((error && <span className="label label-danger">{error}</span>) ||
        (warning && <span className="label label-warning">{warning}</span>))}
        </div>

);

}

export default TextAreaField;


// WEBPACK FOOTER //
// app/components/TextAreaField.jsx